(function ($) {
    var length = $(".sticky-nav ul li").length;
    var sum = 'calc(' + (100 / length) + '% - 44px)';
    $(".sticky-nav ul li").css({'flex-basis': sum, 'max-width': sum})

})(jQuery);